<template>
  <div class="errWrap fc ac">
      <span>哎呀！您访问的页面找不到了！</span>
      <img src="../../../static/imgs/movie/404.png" alt="">
  </div>
</template>

<script>
export default {
    data() {
        return {

        };
    },
    components: {

    },
    created() {

    },
    methods: {

    }

}

</script>
<style scoped lang="scss">
.errWrap {
    span {
        font-size: 28px;
        margin: 200px 0 100px 0;
        color: rgb(69, 145, 189);
    }
    img {
        width: 496px;
        height: 200px;
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/err/errPage.vue